import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class RadarMonitoramentoService extends ApiConfig {
  preVisualizarData = {};
  listarData = {};
  tagsProposicaoData: Object;
  promiseListarTagsProposicao: any;
  promiseLista: Promise<unknown>;
  constructor(private http: HttpClient) {
    super();
  }

  listar(idUsuario) {
    var radarChave = idUsuario;
    if (this.listarData[radarChave])
      return new Promise(async (resolve) => {
        console.log('from cache');
        resolve(JSON.parse(this.listarData[radarChave]));
      });
    if (!this.promiseLista) {
      this.promiseLista = new Promise(async (resolve) => {
        this.http
          .get(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/Listar?idUsuario=' +
              idUsuario,
          )
          .subscribe(
            (data: any) => {
              this.listarData[radarChave] = JSON.stringify(data);
              var data2 = [...data];
              resolve(data2);
              this.promiseLista = undefined;
            },
            (error) => {},
          );
      });
    }
    return this.promiseLista;
  }

  listarTagsProposicao() {
    if (this.tagsProposicaoData)
      return new Promise(async (resolve) => {
        resolve(this.tagsProposicaoData);
      });

    this.promiseListarTagsProposicao = new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/listarTagsProposicao',
        )
        .subscribe(
          (data) => {
            this.tagsProposicaoData = data;
            resolve(data);
            this.promiseListarTagsProposicao = undefined;
          },
          (error) => {},
        );
    });
    return this.promiseListarTagsProposicao;
  }

  listarTagsParlamentar() {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarTagsParlamentar',
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  deletar(id) {
    this.listarData = {};
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/Deletar?id=' +
            id,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarStakeholders(radar, processId) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          `https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarStakeholders2?processId=${processId}`,
          radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  limparCache() {
    this.listarData = {};
  }

  cadastrar(radar) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/criar',
          radar,
        )
        .subscribe(
          (data) => {
            this.Indexar(data);
            this.listarData = {};
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  ingressar(radar) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ingressar',
          radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }

  criarLink(radar) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/criarLink',
          radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }

  tendencia() {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/Tendencia',
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }

  insights(radar, processId) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          `https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/InsightsPorRadar?processId=${processId}`,
          radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  insightsPorProjeto(radar) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/InsightsPorProjeto',
          radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }

  listarProgressaoMovimentacao(radar) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoMovimentacao?' +
            radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  ListarProgressaoMovimentacaoPorProjeto(model) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoMovimentacaoPorProjeto',
          model,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoDocumentoPorProjeto(model) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/listarProgressaoDocumentoPorProjeto',
          model,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoDocumento(radar) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoDocumento?' +
            radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }

  listarProgressaoTwitter(radar) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/listarProgressaoTwitter?' +
            radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoNoticia(radar) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoNoticias?' +
            radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoTwitterPorProjeto(model) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/listarProgressaoTwitterPorProjeto',
          model,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoNoticiaPorProjeto(model) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoNoticiasPorProjeto',
          model,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoNoticiaRadarProjeto(projetoLista) {
    this.listarData = {};
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/listarProgressaoNoticiaRadarProjeto',
          projetoLista,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoDocumentoRadarProjeto(projetoLista) {
    this.listarData = {};
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoDocumentoRadarProjeto',
          projetoLista,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  listarProgressaoMovimentacaoRadarProjeto(projetoLista) {
    this.listarData = {};
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProgressaoMovimentacaoRadarProjeto',
          projetoLista,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  alterar(radar) {
    this.listarData = {};
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/alterar',
          radar,
        )
        .subscribe(
          (data) => {
            this.Indexar(radar.Id);
            resolve(data);
          },
          (error) => {},
        );
    });
  }

  previsualizarIndex(radar) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/PrevisualizarIndex',
          radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  gerarPDF(id, idUsuario) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/gerarPDF?id=' +
            id +
            '&idUsuario=' +
            idUsuario,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  gerarWord(id, idUsuario) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/gerarWord?id=' +
            id +
            '&idUsuario=' +
            idUsuario,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  getGerarWordListaUrl(idLista, idUsuario) {
    var query = new URLSearchParams();
    idLista.forEach((element) => {
      query.append('idLista', element);
    });
    return (
      'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/gerarWordLista?idUsuario=' +
      idUsuario +
      '&' +
      query.toString()
    );
  }
  getGerarPdfListaUrl(idLista, idUsuario) {
    var query = new URLSearchParams();
    idLista.forEach((element) => {
      query.append('idLista', element);
    });
    return (
      'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/gerarPdfLista?idUsuario=' +
      idUsuario +
      '&' +
      query.toString()
    );
  }
  getGerarExcelListaUrl(idLista, idUsuario) {
    var query = new URLSearchParams();
    idLista.forEach((element) => {
      query.append('idLista', element);
    });
    return (
      'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/gerarExcelLista?idUsuario=' +
      idUsuario +
      '&' +
      query.toString()
    );
  }
  gerarExcelLista(idLista, idUsuario) {
    return new Promise(async (resolve) => {
      this.http.get(this.getGerarExcelListaUrl(idLista, idUsuario)).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {},
      );
    });
  }
  gerarWordLista(idLista, idUsuario) {
    return new Promise(async (resolve) => {
      this.http.get(this.getGerarWordListaUrl(idLista, idUsuario)).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {},
      );
    });
  }

  gerarPdfLista(idLista, idUsuario) {
    return new Promise(async (resolve) => {
      this.http.get(this.getGerarPdfListaUrl(idLista, idUsuario)).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {},
      );
    });
  }
  async preVisualizar(radar) {
    var radarStr = JSON.stringify(radar);
    var radarChave = btoa(radarStr);
    if (this.preVisualizarData[radarChave])
      return new Promise(async (resolve) => {
        console.log('from cache');
        resolve(JSON.parse(this.preVisualizarData[radarChave]));
      });
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/Previsualizar',
          radar,
        )
        .subscribe(
          (data) => {
            this.preVisualizarData[radarChave] = JSON.stringify(data);
            console.log('from server');
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  async excel(idRadar, idUsuario) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/excel?idUsuario=' +
            idUsuario +
            '&id=' +
            idRadar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  async InserirProjeto(idRadar, idProjeto, indexar = true) {
    this.preVisualizarData = {};
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/InserirProjeto?idProjeto=' +
            idProjeto +
            '&idRadar=' +
            idRadar,
        )
        .subscribe(
          (data) => {
            if (indexar) this.Indexar(idRadar);
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  async Indexar(id) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/Indexar?id=' +
            id,
        )
        .subscribe(
          (data) => {
            resolve(data);
            this.limparCache();
            localStorage.setItem('RADAR_MODIFICADO', 'true');
          },
          (error) => {},
        );
    });
  }
  async ExcluirProjeto(idRadar, idProjeto) {
    this.preVisualizarData = {};

    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ExcluirProjeto?idProjeto=' +
            idProjeto +
            '&idRadar=' +
            idRadar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
  async preVisualizarProjetoLei(radar) {
    var radarStr = JSON.stringify(radar);
    var radarChave = btoa(radarStr);
    if (this.preVisualizarData[radarChave])
      return new Promise(async (resolve) => {
        console.log('from cache');
        resolve(JSON.parse(this.preVisualizarData[radarChave]));
      });
    else {
      return new Promise(async (resolve) => {
        this.http
          .get(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProjetoLei?idRadar=' +
              radar.Id,
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {},
          );
      });
    }
  }

  async preVisualizarProjetoLeiLista(radar) {
    var radarStr = JSON.stringify(radar);
    var radarChave = btoa(radarStr);
    if (this.preVisualizarData[radarChave])
      return new Promise(async (resolve) => {
        console.log('from cache');
        resolve(JSON.parse(this.preVisualizarData[radarChave]));
      });
    else {
      return new Promise(async (resolve) => {
        this.http
          .post(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/ListarProjetoLeiLista',
            radar,
          )
          .subscribe(
            (data) => {
              this.preVisualizarData[radarChave] = JSON.stringify(data);
              resolve(data);
            },
            (error) => {},
          );
      });
    }
  }

  preVisualizarCount(radar) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/Radar/PrevisualizarCount?' +
            radar,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {},
        );
    });
  }
}
